import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faClock, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import locationImage from '../../assets/fotofrenteoverlay.png'

const LocationSection = () => {
  return (
    <section className="location-section" id="location">
      <div className="container">
        <h2 className="section-title-location">Onde Estamos</h2>
        <div className="location-grid">
          <div className="location-info">
            <div className="info-item">
              <FontAwesomeIcon icon={faMapMarkerAlt} size="2x" className="info-icon" />
              <div>
                <h4>Endereço</h4>
                <p>Av. Nove de Julho, 980 - Jardim Sumare, Ribeirão Preto - SP, 14025-000</p>
              </div>
            </div>
            <div className="info-item">
              <FontAwesomeIcon icon={faClock} size="2x" className="info-icon" />
              <div>
                <h4>Horário de Funcionamento</h4>
                <p>Segunda a Sexta, das 9h às 16h<br/>Sábados, Domingos e Feriados: Fechado</p>
              </div>
            </div>
            <div className="info-item">
              <FontAwesomeIcon icon={faPhone} size="2x" className="info-icon" />
              <div>
                <h4>Telefone</h4>
                <p>(16) 3315-0695</p>
              </div>
            </div>
            <div className="info-item">
              <FontAwesomeIcon icon={faEnvelope} size="2x" className="info-icon" />
              <div>
                <h4>E-mail</h4>
                <p>museu@fmrp.usp.br</p>
              </div>
            </div>
          </div>
          <div className="location-image">
            <img src={locationImage} alt="Localização do Museu" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;